
document.addEventListener('DOMContentLoaded', function() {

  var readMoreButtons = document.querySelectorAll('.read-more');
  readMoreButtons.forEach(function(button) {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      var contentContainer = this.closest('.content-container');
      var content = contentContainer.querySelector('.content .hidden-content');
      var ellipsis = contentContainer.querySelector('.content .ellipsis');
      content.style.display = (content.style.display === 'none' || content.style.display === '') ? 'inline' : 'none';
      ellipsis.style.display = 'none';
      this.style.display = 'none';
    });
  });

});